import React, { Component } from 'react';
import { Place } from '../store/places/types';
import PlaceListItem from './PlaceListItem';
import {IonList, IonListHeader, IonGrid, IonRow, IonCol } from '@ionic/react';
import { render } from 'react-dom';

interface Props {
  isLoggedIn?: boolean;
  visited?: any;
  bucket?: any;
  favorites?: any;
  photos?: any;
  photoDetailsFn?: any;
  places: any;
  hidden: boolean;
  listType: string;
}

class HomeList extends Component<Props> {
  componentDidMount() {
    try {
      let adsbygoogle;
      // @ts-ignore
      (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }

  render() {
    const { places, hidden, listType, isLoggedIn, visited, bucket, favorites, photos, photoDetailsFn } = this.props;
    if (listType === 'photos' && isLoggedIn && photos) {
      return (
        <IonGrid style={hidden ? {display: 'none'} : {}}>
          <IonRow>
          { photos.map((item: any, placeIndex: number) => (
            <IonCol key={`${placeIndex}`} size-lg="4" size-md="4" size-sm="4" size-xs="4">
              <div className="image-container"
                onClick={() => photoDetailsFn(item.park_code, item.id)}
                style={{
                "backgroundImage": `url(${item.url})`,
                "backgroundSize": "100% 100%", "backgroundRepeat": "no-repeat"
                }}></div>
            </IonCol>
          ))}
          </IonRow>
        </IonGrid>
      );
    }
    if (isLoggedIn) {
      let thisPlace = visited;
      if (listType === 'bucket') {
        thisPlace = bucket;
      }
      if (listType === 'favorites') {
        thisPlace = favorites;
      }
      return (
        <>
        <IonList style={hidden ? {display: 'none'} : {}}>
        { thisPlace.map((place: Place, placeIndex: number) => {
            if (placeIndex % 10 === 0) {
              return (
                <span key={`${placeIndex}`}>
                  <ins className="adsbygoogle"
                    style={{"display":"block"}}
                    data-ad-format="fluid"
                    data-ad-layout-key="-fb+5w+4e-db+86"
                    data-ad-client="ca-pub-2796376641761374"
                    data-ad-slot="5269413752"></ins>
                  <PlaceListItem
                    key={`${placeIndex}`}
                    place={place}
                    listType={listType}
                  />
                </span>
              );
            } else {
              return (
                <PlaceListItem
                  key={`${placeIndex}`}
                  place={place}
                  listType={listType}
                />
              ); 
            }
          })
        }
        </IonList>
        </>
      )
    }
    if (places.length === 0) {
      return (
        <IonList style={hidden ? {display: 'none'} : {}}>
          <IonListHeader>
            No Places Found
          </IonListHeader>
        </IonList>
      );
    }
    return (
      <>
      <IonList style={hidden ? {display: 'none'} : {}}>
        { places.map((place: Place, placeIndex: number) => {
          if (placeIndex % 10 === 0) {
            return (
              <span key={`${placeIndex}`}>
                <ins className="adsbygoogle"
                  style={{"display":"block"}}
                  data-ad-format="fluid"
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-2796376641761374"
                  data-ad-slot="5269413752"></ins>
                <PlaceListItem
                  key={`${placeIndex}`}
                  place={place}
                  listType={listType}
                />
              </span>
            );
          } else {
            return (
              <PlaceListItem
                key={`${placeIndex}`}
                place={place}
                listType={listType}
              />
            ); 
          }
        })
      }
      </IonList>
    </>
    );
  }
}

export default HomeList;
